import clsx from 'clsx';

import Icon from '@/components/base/Icon';
import Loader from '@/components/base/Loader';

export const SocialInboxMessageTranslateAction = ({
    awsTranslation,
    toggleAwsTranslation
}: {
    awsTranslation: any;
    toggleAwsTranslation: () => void;
}) => {
    if (awsTranslation?.isLoading) {
        return <Loader className="h-3 w-3 text-icoBlue" />;
    }

    return (
        <Icon
            icon="translate-outline"
            onClick={toggleAwsTranslation}
            className={clsx('text-12 cursor-pointer text-icoGray-500 hover:text-icoBlue', {
                'rounded-md border-none bg-icoBlue text-white hover:bg-white':
                    awsTranslation?.isDisplayed
            })}
        />
    );
};
